const getPaymodeColor = (paymode: string): string => {
  switch (paymode) {
    case 'premium-calling': 
      return 'primary'
    case 'premium-text-message': 
      return 'info'
    case 'dcb': 
      return 'danger'
    default:
      return 'warning'
  }
}

const getTrxStatusColor = (status: string) : string => {
  switch (status) {
    case 'SUCCEED':
      return 'success'
    case 'PENDING':
      return 'primary'
    case 'FAILED':
      return 'danger'
    default:
      return 'warning'
  }
} 

export {
  getPaymodeColor,
  getTrxStatusColor
}
